/* app/js/src/components/topHeader/topHeader.component.scss */
section header {
  background-color: #232f3a;
}
.cursor-pointer {
  cursor: pointer;
}
section {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100vw;
  height: 70px;
}
section header {
  color: #879baf;
  padding-left: 22px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex: 12 0 0;
  -ms-flex: 12 0 0;
  flex: 12 0 0;
}
section header figure {
  margin: 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
section header figure img {
  height: 35px;
}
section header figure svg {
  margin: 0 11px 0 11px;
  cursor: pointer;
}
section header figure figcaption {
  margin-left: 13px;
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  color: #ffffff;
}
section header .channelName {
  font-size: 0.55vw;
  font-weight: bold;
  color: #ffffff;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: default;
  margin-left: 0;
  padding-left: 10px;
  max-width: 250px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
section header .trialLeftMessage {
  font-size: 13px;
  color: #fbd70f;
  overflow: hidden;
  cursor: default;
  padding: 0 15px;
}
section header .trialLeftMessage .bold {
  font-weight: bold;
}
section header .divider {
  border: none;
  width: 1px;
  margin-left: 20px;
  background-color: #455361;
  height: 41px;
}
section header nav {
  margin-left: 44px;
  margin-top: -0.4em;
  display: flex;
  gap: 30px;
}
section header nav .nav-dropdown {
  position: relative;
  display: inline-block;
}
section header nav .nav-dropdown:hover .nav-submenu {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
section header nav .nav-dropdown .nav-submenu {
  display: none;
  position: absolute;
  background: #232f3a;
  padding: 5px 0;
  box-shadow:
    2px 9px 5px -3px rgba(0, 0, 0, 0.2),
    2px 9px 10px 1px rgba(0, 0, 0, 0.14),
    3px 11px 14px 6px rgba(0, 0, 0, 0.12);
  border-top: 1px solid #879baf;
  width: fit-content;
  min-width: 100%;
  z-index: 1;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
section header nav .nav-dropdown .nav-submenu > * {
  padding: 0 20px;
}
section header .tools {
  list-style-type: none;
  padding: 0;
  margin: auto;
  -webkit-flex: 2 0 0;
  -ms-flex: 2 0 0;
  flex: 2 0 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: flex-end;
  justify-content: flex-end;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 100%;
}
section header .tools li.live-broadcast-button {
  height: 100%;
  display: block;
  min-width: 5rem;
  -webkit-user-select: none;
  user-select: none;
}
section header .tools circle-indicator {
  margin-right: 15px;
}
section header .tools ichannel-button {
  margin-right: 36px;
}
section header .tools ichannel-link {
  margin-right: 30px;
}
section header .tools .profile-menu-toggle {
  margin-right: 30px;
  color: #879baf;
  text-decoration: none;
  font-size: 0.9em;
  display: inline-block;
  margin-top: 0.4em;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
section header .tools .profile-menu-toggle i {
  -webkit-transition: transform 0.2s ease;
  transition: transform 0.2s ease;
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
section header .tools .profile-menu-toggle:hover {
  color: #ffffff;
}
section header .tools .profile-menu-toggle.open {
  color: #ffffff;
}
section header .tools .profile-menu-toggle.open i {
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  -ms-transform: rotate(-180deg);
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
}
section clock {
  -webkit-flex: 2 0 0;
  -ms-flex: 2 0 0;
  flex: 2 0 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  max-width: 144px;
}
.dropdown-menu {
  position: relative;
}
.dropdown-menu a {
  text-decoration: none;
}
.dropdown-menu .profile-container {
  cursor: pointer;
  color: #ffffff;
  background-color: #232f3a;
  font-size: 12px;
  line-height: 1em;
  padding: 1em 1.3em;
  border-bottom: 1px solid #2e3e4c;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.dropdown-menu .profile-container > i {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background: #879baf;
  border-radius: 50%;
  margin-right: 0.7em;
  text-transform: capitalize;
  font-style: normal;
  width: 2.5em;
  height: 2.5em;
  min-width: 2.5em;
  color: #ffffff;
}
.dropdown-menu .profile-container > span {
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.logo-container svg:hover polygon {
  -webkit-animation-delay: 0s;
  -webkit-animation-duration: 0.4s;
  -webkit-animation-name: topHeaderIconAnimation;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0s;
  -moz-animation-duration: 0.4s;
  -moz-animation-name: topHeaderIconAnimation;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0s;
  -o-animation-duration: 0.4s;
  -o-animation-name: topHeaderIconAnimation;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0s;
  animation-duration: 0.4s;
  animation-name: topHeaderIconAnimation;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
@-webkit-keyframes topHeaderIconAnimation {
  0% {
    -ms-transform: translateX(0);
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  48% {
    -ms-transform: translateX(20px);
    -webkit-transform: translateX(20px);
    transform: translateX(20px);
  }
  52% {
    opacity: 0;
    -ms-transform: translateX(-20px);
    -webkit-transform: translateX(-20px);
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    -ms-transform: translateX(0px);
    -webkit-transform: translateX(0px);
    transform: translateX(0px);
  }
}
.manage-users-popup ul {
  list-style-type: none;
}
.manage-users-popup ul li {
  line-height: 30px;
  cursor: pointer;
}
.manage-users-popup ul li:hover {
  background-color: #7d8fa1;
}
.manage-users-popup .filter {
  display: flex;
  flex-direction: row;
}
.manage-users-popup .filter input {
  width: 100%;
}
.censorship-ai-report {
  height: auto !important;
}
.censorship-ai-report label {
  color: #7d8fa1 !important;
  font-weight: bold;
}
.censorship-ai-report .fields .field {
  margin-top: 10%;
}
.export-segments-report,
.censorship-ai-report {
  height: 400px;
}
.export-segments-report .fields,
.censorship-ai-report .fields {
  margin-top: 30px;
}
.export-segments-report .fields input,
.censorship-ai-report .fields input {
  margin-left: 15px;
}
.export-segments-report .fields input,
.export-segments-report .fields label,
.censorship-ai-report .fields input,
.censorship-ai-report .fields label {
  cursor: pointer;
}
.export-segments-report .buttons,
.censorship-ai-report .buttons {
  margin-top: 261px;
  text-align: right;
}
.ai-report-buttons {
  text-align: right;
}
/*# sourceMappingURL=topHeader.component.css.map */
